import React, { useState, useEffect } from 'react'
import { Table } from '../../Table/Table'
import { LoaderButton } from '../../LoaderButton/LoaderButton'
import { S_NotifyDebtors } from './NotifyDebtors.style'
import { getScheduleNotificationPreview } from '../../../_services/lender.service'
import { FaArrowLeft, FaEye } from 'react-icons/fa'
export const NotifyDebtors = ({ debtors, onSelectionFinished, btnText = 'Purchase', invoiceScheduleId }) => {
  const [selectedDebtors, setSelectedDebtors] = useState([])
  useEffect(() => {
    setSelectedDebtors(debtors.map((debtor) => ({ ...debtor, will_notify: false })))
  }, [])
  const [previewing, setPreviewing] = useState(false)
  const [previewHtml, setPreviewHtml] = useState('')
  const [notifying, setNotifying] = useState(false)

  const debtorSelection = () => {
    return (
      <>
        <h2>Notify Debtors</h2>
        <Table
          columns={[
            {
              accessor: 'debtor_name',
              headingText: 'Debtor',
            },
            {
              accessor: 'will_notify',
              headingText: 'Notify?',
              textAlignment: 'right',
              Header: (props) => {
                const { headingText = '', textAlignment = 'right', canSort } = props.column
                return (
                  <div className={`rt-custom-header align-${textAlignment}`}>
                    <span>
                      Notify?&nbsp;
                      <input
                        defaultChecked={selectedDebtors.every((d) => d.will_notify)}
                        onChange={(e) => {
                          let isChecked = e.target.checked
                          setSelectedDebtors((prev) =>
                            prev.map((debtor) => {
                              return {
                                ...debtor,
                                will_notify: isChecked,
                              }
                            })
                          )
                        }}
                        title="Select all."
                        type="checkbox"
                      />
                    </span>
                  </div>
                )
              },
              Cell: (props) => {
                const { textAlignment = 'left', overflow = false } = props.column
                return (
                  <div className={`rt-custom-cell align-${textAlignment} ${overflow ? '_overflow' : ''}`}>
                    <FaEye
                      className={'preview'}
                      onClick={() =>
                        getScheduleNotificationPreview(invoiceScheduleId, props.row.original.id).then((resp) => {
                          setPreviewHtml(resp)
                          setPreviewing(true)
                        })
                      }
                      title={'Preview'}
                    />

                    <input
                      checked={props.value}
                      id={props.row.original.id}
                      onChange={(e) => {
                        let isChecked = e.target.checked
                        setSelectedDebtors((prev) =>
                          prev.map((debtor) => {
                            return {
                              ...debtor,
                              will_notify: debtor.id == props.row.original.id ? isChecked : debtor.will_notify,
                            }
                          })
                        )
                      }}
                      type="checkbox"
                    />
                  </div>
                )
              },
            },
          ]}
          data={selectedDebtors}
          pageSize={debtors.length}
        />
        <div className={'btn-row'}>
          <LoaderButton
            isLoading={notifying}
            onClick={async () => {
              setNotifying(true)
              // expected to return a promise
              await onSelectionFinished(selectedDebtors.filter((d) => d.will_notify).map((d) => d.id))
              setNotifying(false)
            }}
          >
            {btnText}
          </LoaderButton>
        </div>
      </>
    )
  }

  const preview = () => {
    return (
      <div>
        <FaArrowLeft className="back-arrow" onClick={() => setPreviewing(false)} />
        <iframe className={`email-preview`} src={`data:text/html;base64,${btoa(previewHtml)}`} width="550px" />
      </div>
    )
  }

  return <S_NotifyDebtors>{previewing ? preview() : debtorSelection()}</S_NotifyDebtors>
}
